<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">

        <!-- Header -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px;">
          <div>
            <h1 style="margin-bottom: 8px;">Sync #{{ syncId }} — Per-App Logs</h1>
            @if (syncHistory) {
              <p class="text-muted">{{ getSyncTypeLabel(syncHistory) }} · {{ formatDate(syncHistory.startedAt) }}</p>
            }
          </div>
          <button type="button" class="btn btn-primary no-arrow" (click)="goBack()">
            Back to Sync History
          </button>
        </div>

        <!-- Error -->
        @if (error) {
          <div class="alert alert-danger"><mat-icon>error</mat-icon> {{ error }}</div>
        }

        @if (pageLoading) {
          <app-sync-item-logs-skeleton></app-sync-item-logs-skeleton>
        }

        <!-- Summary Card -->
        @if (!pageLoading && syncHistory) {
          <div class="card" style="margin-bottom: 20px;">
            <div class="card-header"><h5>Summary</h5></div>
            <div class="card-body">
              <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 15px;">
                <div>
                  <strong>Type:</strong>
                  <span class="badge badge-secondary" style="margin-left: 8px;">{{ getSyncTypeLabel(syncHistory) }}</span>
                </div>
                <div><strong>Started:</strong> {{ formatDate(syncHistory.startedAt) }}</div>
                <div><strong>Completed:</strong> {{ formatDate(syncHistory.completedAt) }}</div>
                <div><strong>Duration:</strong> {{ formatDuration(syncHistory) }}</div>
                @if (syncHistory.recordsInserted > 0) {
                  <div><strong>Inserted:</strong> <span class="badge badge-success">{{ syncHistory.recordsInserted }}</span></div>
                }
                @if (syncHistory.recordsUpdated > 0) {
                  <div><strong>Updated:</strong> <span class="badge badge-info">{{ syncHistory.recordsUpdated }}</span></div>
                }
                <div><strong>Skipped:</strong> <span class="badge badge-secondary">{{ syncHistory.recordsSkipped }}</span></div>
                @if (syncHistory.recordsErrored > 0) {
                  <div><strong>Failed:</strong> <span class="badge badge-danger">{{ syncHistory.recordsErrored }}</span></div>
                }
                @if (syncHistory.triggeredBy) {
                  <div><strong>Triggered By:</strong> {{ syncHistory.triggeredBy }}</div>
                }
              </div>
            </div>
          </div>
        }

        <!-- Per-App Log Table -->
        @if (!pageLoading) {
        <div class="card">
          <div class="card-header"><h5>Per-Application Log</h5></div>
          <div class="card-body">

            @if (!loading && items.length === 0 && !hasActiveFilters()) {
              <div class="alert alert-info">
                <mat-icon>info</mat-icon>
                No per-app log items for this sync run. Items are only recorded for <strong>Inserted</strong>, <strong>Updated</strong>, and <strong>Failed</strong> apps — skipped apps show only as a count above.
              </div>
            }

            <div class="table-responsive">
              @if (loading) {
                <app-sync-item-logs-table-skeleton></app-sync-item-logs-table-skeleton>
              }

              @if (!loading) {
                <table class="table table-sm table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Application</th>
                      <th>Action</th>
                      <th>SysId</th>
                      <th>Error</th>
                    </tr>
                    <tr class="filter-row">
                      <th>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          [(ngModel)]="filterAppName"
                          (input)="onFilterTextChange()"
                          (keyup.enter)="applyFilters()"
                          placeholder="Filter by name...">
                      </th>
                      <th>
                        <select
                          class="form-control form-control-sm"
                          [(ngModel)]="filterAction"
                          (change)="applyFilters()">
                          <option value="">All</option>
                          <option value="Inserted">Inserted</option>
                          <option value="Updated">Updated</option>
                          <option value="Failed">Failed</option>
                        </select>
                      </th>
                      <th></th>
                      <th>
                        @if (hasActiveFilters()) {
                          <button
                            type="button"
                            class="btn btn-sm btn-danger no-arrow"
                            (click)="clearFilters()"
                            title="Clear all filters">
                            <mat-icon style="font-size: 16px; height: 16px; width: 16px;">clear</mat-icon>
                          </button>
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of items; track item.id) {
                      <tr>
                        <td><strong>{{ item.appName }}</strong></td>
                        <td>
                          <span [class]="'badge ' + getActionBadgeClass(item.action)">
                            <mat-icon style="font-size: 14px; height: 14px; width: 14px;">{{ getActionIcon(item.action) }}</mat-icon>
                            {{ item.action }}
                          </span>
                        </td>
                        <td class="text-muted" style="font-size: 0.85em;">{{ item.sysId || '-' }}</td>
                        <td>
                          @if (item.errorMessage) {
                            <span class="text-danger" [title]="item.errorMessage" style="font-size: 0.85em;">
                              {{ item.errorMessage.length > 80 ? item.errorMessage.substring(0, 80) + '...' : item.errorMessage }}
                            </span>
                          } @else {
                            <span class="text-muted">-</span>
                          }
                        </td>
                      </tr>
                    }
                    @if (!loading && items.length === 0 && hasActiveFilters()) {
                      <tr>
                        <td colspan="4" style="text-align: center; padding: 20px; color: #666;">
                          No items match the current filters.
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>

                <mat-paginator
                  [length]="itemsTotal"
                  [pageSize]="pageSize"
                  [pageIndex]="pageNumber - 1"
                  [pageSizeOptions]="[20, 50, 100]"
                  [showFirstLastButtons]="true"
                  (page)="onPageChange($event)">
                </mat-paginator>
              }
            </div>
          </div>
        </div>
        }

      </div>
    </div>
  </section>
</main>
